import axios from "axios";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class AuthService {

    static login(item) {
        return axios.post(API_BASE_URL + API_PATHS.login, item)
        .then((response) => {
            if (response?.data && response?.data?.status === 1) { 
                localStorage.setItem("users", JSON.stringify(response.data));
                localStorage.setItem("accessToken", response.data.data.accessToken);
                localStorage.setItem("refreshToken", response.data.data.refreshToken);
                return response.data;
            } else {
                // If the login attempt was unsuccessful, throw an error
                throw new Error(response?.data?.message || 'Invalid credintials');
            }
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}

static FetchProfile(item) {
   
    let api = '';
    if(item?.id){
       api= `${API_BASE_URL}${API_PATHS.fetchprofile}?id=${item.id}`
    }else{
    api = `${API_BASE_URL}${API_PATHS.fetchprofile}?page=${item?.page}&limit=${item?.limit}`;
    }
    return axiosInstance.get(api)
}

static addhoteladmin(item) {
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addhotelAdmin}`;
    return axiosInstance
        .post(api,item)
        
}

static getHotelAdmin(item) {
    let api = '';

    if (item?.id) {
        api = `${API_BASE_URL}${API_PATHS.gethotelAdmin}?id=${item.id}`;
    } else {
        api = `${API_BASE_URL}${API_PATHS.gethotelAdmin}?limit=${item.limit}&page=${item.page}`;

        if (item?.hotelName) {
            api += `&hotelName=${encodeURIComponent(item.hotelName)}`;
        }
    }

    return axiosInstance.get(api);
}


static editHotelAdmin(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.edithotelAdmin}`;
    return axiosInstance
        .put(api,item)
        
}



    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) :"";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
                    localStorage.setItem("accessToken", data.data.accessToken);
                    localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default AuthService;
